/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Reformulation_AcceptedInputs */

const en_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted`)
};

const de_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akzeptiert`)
};

const fr_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepté`)
};

const es_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptado`)
};

const it_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accettato`)
};

const nl_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geaccepteerd`)
};

const pl_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaakceptowano`)
};

const fi_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyväksytty`)
};

const da_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepteret`)
};

const sv_keyword_optimizer_reformulation_accepted = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godkänt`)
};

/**
* | output |
* | --- |
* | "Accepted" |
*
* @param {Keyword_Optimizer_Reformulation_AcceptedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_reformulation_accepted = /** @type {((inputs?: Keyword_Optimizer_Reformulation_AcceptedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Reformulation_AcceptedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_reformulation_accepted(inputs)
	if (locale === "fr") return fr_keyword_optimizer_reformulation_accepted(inputs)
	if (locale === "es") return es_keyword_optimizer_reformulation_accepted(inputs)
	if (locale === "it") return it_keyword_optimizer_reformulation_accepted(inputs)
	if (locale === "nl") return nl_keyword_optimizer_reformulation_accepted(inputs)
	if (locale === "pl") return pl_keyword_optimizer_reformulation_accepted(inputs)
	if (locale === "fi") return fi_keyword_optimizer_reformulation_accepted(inputs)
	if (locale === "da") return da_keyword_optimizer_reformulation_accepted(inputs)
	if (locale === "sv") return sv_keyword_optimizer_reformulation_accepted(inputs)
	return en_keyword_optimizer_reformulation_accepted(inputs)
});